import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  id: number;
};
type Response = null;

export const useLockCar = createMutation<Response, Variables, AxiosError>({
  mutationFn: async ({ id }) =>
    client({
      url: `v2/internal/partners/cars/${id}/lock`,
      method: 'POST',
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
